import { Hotspot } from "../Objects/hotspot";

export class Scene{

    constructor(appManager, sceneData, id){
        this.appManager = appManager
        this.id = id
        this.model = sceneData.model || undefined
        this.title = sceneData.details.scene_title || undefined
        this.prompt = sceneData.details.description || undefined
        this.animStart = sceneData.details.animation.animation_start || undefined
        this.animEnd = sceneData.details.animation.animation_end || undefined
        this.zoomLevel = sceneData.details.zoom || undefined
        this.transparent =  sceneData.highlighting.is_transparent
        this.highlightedParts = sceneData.highlighting.highlighted_parts || undefined
        this.highlightedPartsRef = []
        this.hotspotIDs = sceneData.hotspots || undefined
        this.hotspots = []
        //this.hotspotsArray = []

        this.initialise()
        this.getHotspots()
    }

    initialise(){
        //this.loadModel()
        //this.createHotspots()
    }

    displayScene(){
        this.setZoomLevel()
        this.setAnimation()
        this.setTransparency()
        this.setHighlightedParts()
        this.appManager.sceneHistory.push(this.id+1)
        this.updateUI()
    }

    loadModel(){
        if(this.model != undefined)
            this.appManager.loadModel(this.model)
    }
    createHotspots(){
        if(this.hotspots == undefined) return

        /* this.hotspots.forEach((hotspotData) => {
            this.hotspotsArray.push(new Hotspot(this.appManager, hotspotData))
        }) */
    }
    getHotspots(){
        if(this.hotspotIDs == undefined) return
        this.hotspotIDs.forEach((id) => {
            this.hotspots.push(this.appManager.hotspotManager.getHotspotById(id.hotspot_id))
        })
    }

    updateUI(){
        document.getElementById('experienceTitle').innerHTML = this.title
        if(this.prompt == undefined) this.prompt = " "
        document.getElementById('overlaidInstructionsText').innerHTML = this.prompt
        document.getElementById('overlaidInstructionsText').classList.remove("hide")
        document.getElementById('overlaidInstructions').classList.remove("hide")
    }
    setZoomLevel(){
        if(this.zoomLevel != undefined)
            this.appManager.cameraManager.zoomCameraTo(this.zoomLevel)
    }
    setAnimation(){
        if(this.animStart == undefined) return    
        if(this.animEnd == undefined) return

        this.appManager.modelManager.currentModel.animationController.animationGroups[0].stop()
        this.appManager.modelManager.currentModel.animationController.animationGroups[0]
            .start(false, 1, this.animStart, this.animEnd); 

        //this.setHotspotVisibility(true)


    }
    setTransparency(){
        this.appManager.transparentController.setAllTransparent(this.transparent)
    }
    setHighlightedParts(){
        if(this.highlightedParts == undefined) return
        this.appManager.transparentController.highlightParts(this.highlightedParts)
    }

    setHotspotVisibility(value){
        this.hotspots.forEach((hotspot) => {
            hotspot.setVisibility(value)
        })
    }
}